module.exports = __webpack_public_path__ + "static/23-9bd39b9a952be9e7fc47bb4d6c2ef919.png";